
import { Vue, Component, Ref } from 'vue-property-decorator'
import ListView from '@/components/ListView.vue'
import DateSelect from '@/components/DateSelect.vue'
import ShopAutocomplete from '@/components/ShopAutocomplete.vue'

@Component({
  components: { ListView, DateSelect, ShopAutocomplete },
})
export default class DynamicPricingDetailPage extends Vue {
  @Ref() readonly listView!: ListView

  filterDefinition = {
    ordering: { type: String, default: '-created' },
    dateFrom: { type: String, default: null },
    dateTo: { type: String, default: null },
    shop: { type: String, default: null },
  }
  filter: null | Record<string, any> = null

  headers = [
    { text: 'ID', value: 'id' },
    { text: '店舗コード', value: 'shopCode' },
    { text: '店舗', value: 'shopName' },
    { text: '適用開始日時', value: 'start' },
    { text: '適用終了日時', value: 'end' },
    { text: '値引額', value: 'amount' },
    { text: '登録日時', value: 'created' },
    { text: '更新日時', value: 'updated' },
  ]

  updateQuery() {
    if (this.filter !== null) {
      this.listView.updateQuery(this.filter)
    }
  }
}
